import React from 'react';
import Header from './Header';
import ContactButton from './ContactButton';
import PartnersBar from './PartnersBar';
import DarkVeil from './DarkVeil/DarkVeil';
import RotatingText from './RotatingText/RotatingText';

// Hero section containing the dynamic background, static hero content and partner logos
const Hero = () => {
  return (
    <section id="home" className="hero-section">
      <Header />
      <div className="hero-background">
        {/* più attività: includi tutti i blob */}
        <DarkVeil />   
      </div>
      <div className="hero-content">
        <h1 className="hero-heading">
          <span className="gradient-text word-animation">Because</span>{' '}
          <span className="word-animation">Change</span>{' '}
          <span className="gradient-text word-animation">Happens</span>
          <span className="gradient-text word-animation">.</span>
        </h1>
        <div className="hero-rotating-text word-animation">
          <RotatingText
            texts={[
              'Sicurezza informatica senza compromessi',
              'Infrastrutture IT scalabili e resilienti',
              'Il tuo partner tecnologico',
              'Protezione avanzata contro le minacce cyber',
              'Cloud computing per la tua crescita aziendale',
              'Supporto IT proattivo e personalizzato',
              'Backup e disaster recovery garantiti',
              'Reti aziendali veloci e protette',
              'Compliance e governance IT su misura',
              'Trasformazione digitale al tuo fianco',
              'Monitoraggio 24/7 della tua infrastruttura',
              'Soluzioni enterprise per ogni esigenza',
              'Innovazione tecnologica continua'
            ]}
            rotationInterval={3000}
            staggerDuration={0.02}
            staggerFrom="first"
          />
        </div>
        {/* Inserisci il pulsante qui, subito dopo l'heading */}
        <ContactButton />
      </div>
      <PartnersBar />
    </section>
  );
};

export default Hero;